import { Outlet } from "react-router-dom";
import Header from "./header";
import SideMenu from "./sidemenu";

const SIDEMENU_WIDTH = 257;
const HEADER_HEIGHT = 76;

const LayoutWithTopBar = () => {
  return (
    <div className="w-full h-screen overflow-x-hidden">
      <SideMenu />

      <div
        className="contentWidth flex flex-col"
        style={{
          marginLeft: `${SIDEMENU_WIDTH}px`,
          paddingTop: `${HEADER_HEIGHT}px`,
        }}
      >
        <div
          className="fixed top-0 right-0 bg-white"
          style={{
            left: `${SIDEMENU_WIDTH}px`,
            height: `${HEADER_HEIGHT}px`,
            width: `calc(100% - ${SIDEMENU_WIDTH}px)`,
            zIndex: 11,
          }}
        >
          <Header />
        </div>

        <div className="pb-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LayoutWithTopBar;
